import { Icon } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { withTheme } from 'styled-components';

import { MoreInformationModal } from '../MoreInformationModals';

const GiftMessageMoreInformationModal = ({ theme, isModalOpen, onRequestClose }) => {
  const { t } = useTranslation();
  return (
    <MoreInformationModal
      isModalOpen={isModalOpen}
      onRequestClose={onRequestClose}
      contentList={[
        {
          title: t('giftMessage'),
          description: t('giftMessageInfoModalGiftWrapperDesc'),
          icon: (
            <Icon
              name="messaging"
              color="var(--color-accent-primary-default)"
              style={{ marginRight: 16, marginTop: 4 }}
            />
          )
        },
        {
          title: t('giftWrapper'),
          description: t('giftMessageInfoModalDesc'),
          icon: (
            <Icon
              name="gift-box"
              color="var(--color-accent-primary-default)"
              style={{ marginRight: 16, marginTop: 4 }}
            />
          ),
          images: [
            {
              src: theme.images.giftWrapper,
              alt: t('chooseYourBrandingType', { type: t('digitalWrapper').toLocaleLowerCase() })
            }
          ]
        },
        {
          title: t('aboutMessage'),
          description: t('giftMessageInfoModalAboutMsgDesc'),
          icon: (
            <Icon
              name="orders"
              color="var(--color-accent-primary-default)"
              style={{ marginRight: 16, marginTop: 4 }}
            />
          )
        },
        {
          title: t('yourLogo'),
          description: t('giftMessageInfoModalGiftWrapperDesc'),
          icon: (
            <Icon
              name="picture"
              color="var(--color-accent-primary-default)"
              style={{ marginRight: 16, marginTop: 4 }}
            />
          )
        }
      ]}
    />
  );
};

export default withTheme(GiftMessageMoreInformationModal);
